import React, { useEffect, useState } from "react";
import { DROPZONE_MAX_FILE_3MB } from "../../../../App/configs/DropzoneConfig";
import { Upload } from "antd";
import { toast } from "react-toastify";

const { Dragger } = Upload;

const DropzoneContract = ({
  existingFile,
  setFileUploaded,
  fileUploaded,
}: any) => {
  const [fileList, setFileList] = useState<any>([]);

  useEffect(() => {
    if (existingFile) {
      setFileList([
        {
          uid: "-1",
          name: existingFile,
          status: "done",
        },
      ]);
    }
  }, [existingFile]);

  const handleBeforeUpload = (file: any) => {
    const isPDF = file.type === "application/pdf";
    const isLt3MB = file.size <= DROPZONE_MAX_FILE_3MB; // Convert bytes to MB

    if (!isPDF) {
      toast.error("Only PDF files are allowed!");
      return false;
    }

    if (!isLt3MB) {
      toast.error("File must be 3MB or smaller!");
      return false;
    }
    setFileList([
      { uid: file?.uid, name: file?.name, status: "done", originFileObj: file },
    ]);
    // Prepare FormData
    const formData = new FormData();
    formData.append("contract_file", file);

    // Pass FormData to parent
    setFileUploaded(formData);
    return false; // Prevent auto-upload
  };

  return (
    <div>
      <Dragger
        accept={".pdf"}
        fileList={fileList}
        beforeUpload={handleBeforeUpload}
        onRemove={() => {
          setFileList([]);
          setFileUploaded(null);
        }}
        itemRender={
          !fileUploaded && existingFile
            ? () => (
                <a
                  href={existingFile}
                  target={"_blank"}
                  style={{ padding: "8px 0", fontWeight: "500" }}
                  className={"truncate1"}
                  rel="noreferrer"
                >
                  Download contract file{" "}
                  <i
                    style={{ fontSize: 16 }}
                    className="uil uil-file-download"
                  ></i>
                </a>
              )
            : undefined
        }
      >
        <p className="ant-upload-drag-icon">
          <i style={{ fontSize: 48 }} className="uil uil-cloud-upload" />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">Supports a single file upload.</p>
      </Dragger>
    </div>
  );
};

export default DropzoneContract;
